import InventoryCheck from "./InventoryCheck";

const inventoryCheck = {
  path: "inventory-check",
  sideNav: {
    group: 4,
    order: 73,
    label: "Inventory Check",
    entityType: "all",
    allowedRole: ["admin", "inv_check"],
    auth: ["authenticated"],
  },
  route: {
    index: {
      Comp: InventoryCheck,
      allowedRole: ["admin", "inv_check"],
      entityType: "all",
      auth: ["authenticated"],
    },
  },
};

export default inventoryCheck;
